export default function GooglePlacesTypeaheadService() {
    'ngInject';

    const COUNTRY_FIELD = 'country';
    const POSTAL_TOWN_FIELD = 'postal_town';
    const ADMINISTRATIVE_AREA_FIELD = 'administrative_area_level_1';
    const ADMINISTRATIVE_AREA_FIELD_SECONDARY = 'administrative_area_level_2';
    const LOCALITY_FIELD = 'locality';
    const MIN_LEN_FOR_SHORT_NAME = 3;

    return {
        extractPlaceInfo,
    };

    function extractPlaceInfo(place) {
        const addressInfo = extractAddressInfo(place.address_components);
        addressInfo.info.unshift(place.name);

        const addressText = addressInfo.info.join(', ');

        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        const {countryCode, administrativeAreaLevel1} = addressInfo;
        addressInfo.info.pop();
        addressInfo.info.push(countryCode);
        const altAddress = addressInfo.info.join(', ');

        return {
            cityName: addressInfo.cityName,
            countryCode,
            administrativeAreaLevel1,
            latitude,
            longitude,
            addressText,
            altAddress,
            isAirport: (place.types || []).includes('airport'),
        };
    }

    function extractAddressInfo(addressComponents) { // eslint-disable-line
        const length = addressComponents.length;
        const info = [];
        let countryCode;
        let cityName;
        let administrativeAreaLevel1;
        let locality;

        function prepareCityNameField(shortName, longName) {
            if (shortName) {
                return shortName.length <= MIN_LEN_FOR_SHORT_NAME
                    ? longName
                    : shortName;
            }
            return longName;
        }
        for (let i = 0; i < length; ++i) {
            const SHORT_NAME = addressComponents[i].short_name;
            const LONG_NAME = addressComponents[i].long_name;
            const TYPE = addressComponents[i].types[0];

            if (TYPE === COUNTRY_FIELD) {
                info.push(LONG_NAME);
                countryCode = SHORT_NAME;
            } else if (TYPE === POSTAL_TOWN_FIELD) {
                cityName = prepareCityNameField(SHORT_NAME, LONG_NAME);
                info.unshift(LONG_NAME);
            } else if (TYPE === ADMINISTRATIVE_AREA_FIELD) {
                administrativeAreaLevel1 = SHORT_NAME;
            } else if (TYPE === ADMINISTRATIVE_AREA_FIELD_SECONDARY && !administrativeAreaLevel1) {
                administrativeAreaLevel1 = SHORT_NAME;
            } else if (TYPE === LOCALITY_FIELD) {
                locality = prepareCityNameField(SHORT_NAME, LONG_NAME);
            }
        }

        // fix for ukr cities like 'Kyiv' google places not returning 'locality' field, for 'Kiev' if works ok
        if (!cityName) {
            cityName = locality || administrativeAreaLevel1;
        }

        return {
            countryCode,
            administrativeAreaLevel1,
            info,
            cityName,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/google-places/google-places-typeahead-service.js